<template>
  <div class="SignalsBox" :class="{ blur: blur }">
    <div
      class="innerBox"
      @click="setShowSignalModal({ showPopup: true, signal })"
    >
      <div class="content-blur" v-if="isblur"></div>
      <div class="symbol-top-container">
        <img :src="symbolImageUrl" class="icon-symbol" />
        <div class="instrument">
          <div class="title-container">
            <h2>{{ signal.symbol }}</h2>
          </div>
          <!--            currently traderDict is available due initialization at loginOrRegister component-->
          <span class="currency-vs">{{
            traderDict(signal.symbolDescription)
          }}</span>
        </div>
      </div>
      <div class="middleDetails">
        <div class="middleDiv">
          <ul class="top">
            <li>{{ formattedTime }}</li>
            <li>
              <span class="noMargin">{{ t("Signal_Validity") }}</span>
              <span class="info hasTooltip" @click="clickOnTooltip"
                >:
                <svg
                  data-v-6a01939c=""
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path data-v-6a01939c="" d="M0,0H24V24H0Z" class="a"></path>
                  <path
                    data-v-6a01939c=""
                    d="M7.4,5H8.6V6.2H7.4Zm0,2.4H8.6V11H7.4ZM8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2ZM8,12.8A4.8,4.8,0,1,1,12.8,8,4.806,4.806,0,0,1,8,12.8Z"
                    transform="translate(4.115 4.115)"
                    class="b"
                  ></path>
                </svg>
                <span class="tooltip">
                  {{ t("Signal_validity_info") }}
                </span>
              </span>
              <span class="grey"> {{ t(signal.validity) }}</span>
            </li>
          </ul>
          <ul class="bottom">
            <li>
              <span>{{ t("type_label") }}</span>
              <span>{{ t([signal.type === "buy" ? "Assets_Buy" : "Assets_Sell"]) }}</span>
            </li>
            <li>
              <span>{{ t("Entry_Point") }}</span>
              <span>{{ signal.last }}</span>
            </li>
            <li>
              <span>{{ t("tp_label") }}</span>
              <span>{{ signal.tp }}</span>
            </li>
            <li>
              <span>{{ t("sl_label") }}</span>
              <span>{{ signal.sl }}</span>
            </li>
          </ul>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <defs>
            <clipPath id="a">
              <rect class="a" width="24" height="24" />
            </clipPath>
            <clipPath id="b">
              <rect
                class="b"
                width="24"
                height="24"
                transform="translate(0 0)"
              />
            </clipPath>
          </defs>
          <g class="c">
            <g class="d">
              <path
                class="b"
                d="M7.4,1.4,6,0,0,6l6,6,1.4-1.4L2.8,6Z"
                transform="translate(16.4 18) rotate(180)"
              />
              <rect
                class="a"
                width="24"
                height="24"
                transform="translate(0 0)"
              />
            </g>
          </g>
        </svg>
      </div>
      <div class="btnWrap">
        <div
          v-if="signal.type === 'sell'"
          class="btn clearBtn"
          @click.prevent="clickOnAction($event, signal, 'sell')"
        >
          <span>{{ t("Assets_Sell") }}</span>
          <span :class="['symbolPrice', visualPrice(price, 'cb')]"
            >&nbsp;{{ visualPrice(price, "b", "d") }}</span
          >
        </div>
        <div
          v-else
          class="btn clearBtn"
          @click.prevent="clickOnAction($event, signal, 'buy')"
        >
          <span>{{ t("Assets_Buy") }}</span>
          <span :class="['symbolPrice', visualPrice(price, 'ca')]"
            >&nbsp;{{ visualPrice(price, "a", "d") }}</span
          >
        </div>
        <div class="blue-text">
          <span
            v-if="signal.type === 'buy'"
            @click.prevent="clickOnAction($event, signal, 'sell')"
          >
            {{ t("or_sell_above") }}&nbsp;{{ signal.pivot }}
          </span>
          <span v-else @click.prevent="clickOnAction($event, signal, 'buy')">
            {{ t("or_buy_below") }}&nbsp;{{ signal.pivot }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import { scrollToForm } from "@/utils/general";
import { visualPrice } from "@/utils/symbolsSocket";

import moment from "moment";

export default {
  name: "CardSignal",
  props: ["signal", "price", "blur"],
  computed: {
    ...mapState(["lang", "isLoggedIn"]),
    ...mapGetters([
      "t",
      "traderDict",
      "userPlatformSignalInfoLinkBase",
      "baseImgUrl"
    ]),
    isblur: function() {
      return this.blur;
    },
    symbolImageUrl: function() {
      return this.baseImgUrl + this.signal.symbolImage;
    },
    resistanceRange: function() {
      let sorted = [
        this.signal.resistance1,
        this.signal.resistance2,
        this.signal.resistance3
      ].sort();
      return sorted[sorted.length - 1] + " - " + sorted[0];
    },
    supportRange: function() {
      let sorted = [
        this.signal.support1,
        this.signal.support2,
        this.signal.support3
      ].sort();
      return sorted[sorted.length - 1] + " - " + sorted[0];
    },
    formattedTime: function() {
      moment.locale(this.lang);
      //important note: adding 1 hour after discussing with Itay, as a solution for time gap between the service response and the time appears at the signals graph
      return moment(this.signal.time)
        .add(1, "hours")
        .format("DD MMM YY, HH:mm");
    }
  },
  methods: {
    ...mapMutations(["setShowNotificationModal"]),
    ...mapMutations("signals", ["setShowSignalModal"]),
    visualPrice: visualPrice,
    clickOnAction(event, signal, type) {
      event.stopPropagation();
      if (!this.isLoggedIn) {
        scrollToForm();
      } else {
        window.location.href = this.userPlatformSignalInfoLinkBase(
          signal,
          type
        );
      }
    },
    clickOnTooltip(event) {
      if (window.matchMedia("(max-width: 768px)").matches) {
        event.stopPropagation();
        this.setShowNotificationModal(true);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.SignalsBox {
  width: 328px;
  &.blur {
    .innerBox {
      border: none;
      //.symbol-top-container {
      //  margin-bottom: 0;
      //}
    }
    .more-info {
      display: none !important;
    }
    .middleDetails ul li span:last-of-type,
    .btnWrap .symbolPrice {
      text-transform: uppercase;
      letter-spacing: -1px;
      font-weight: bold;
      text-shadow: 0 0 10px black;
      color: transparent;
    }
  }
  .innerBox {
    position: relative;

    &:hover {
      cursor: pointer;
    }
    .content-blur {
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0px;
      background-color: rgba(255, 255, 255, 0.8);
      z-index: 5;
    }
    .symbol-top-container {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f5f5f5;
      padding: 0 16px;
      height: 70px;
      border-radius: 3px;
      margin: 0 0 4px 0;
      .icon-symbol {
        width: 36px;
      }
      .instrument {
        width: 100%;
        padding: 0 0 0 16px;
        .title-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          h2 {
            font-size: 1.25rem;
          }
        }
        .currency-vs {
          font-size: 14px;
          color: #9e9e9e;
        }
      }
    }
    .more-info {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translatey(-50%);
      z-index: 1;
      .a {
        fill: none;
      }
      .b {
        fill: #9e9e9e;
      }
      .c {
        clip-path: url(#a);
      }
      .d {
        clip-path: url(#b);
      }
      &:hover {
        cursor: pointer;
        .b {
          fill: #7a7c7c;
        }
      }
    }
    .middleDetails {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 1rem 0;
      .middleDiv {
        width: 100%;
        ul {
          position: relative;
          padding: 0;
          &.top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            li:last-of-type {
              display: flex;
              align-items: center;
            }
          }
          &.bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 18px;
            li {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              span:first-of-type {
                font-size: 0.75rem;
              }
            }
          }
          li {
            display: flex;
            font-size: 14px;
            text-transform: capitalize;
            align-items: center;
            > span {
              &:first-of-type, &.grey{
                color: #9e9e9e;
              }
              &.signal-info {
                cursor: pointer;
              }
              &.noMargin {
                margin: 0;
              }
              .tooltip {
                color: #ffffff;
                font-size: 0.875rem;
                background: #424242;
              }
            }
            svg {
              .a {
                fill: none;
              }
              .b {
                fill: #9e9e9e;
              }
            }
            .info {
              display: flex;
              justify-content: flex-start;
              position: relative;
              margin: 0;
              background-position: 3px 0;
              background-repeat: no-repeat;
              color: #9e9e9e;
              .hasTooltip {
                &:after {
                  content: ":";
                  display: block;
                }
              }
            }
          }
        }
      }
      > svg {
        .a {
          fill: none;
        }
        .b {
          fill: #7a7c7c;
        }
        .c {
          clip-path: url(#a);
        }
        .d {
          clip-path: url(#b);
        }
      }
    }
    .btnWrap {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 0.25rem;
      .btn {
        width: 100%;
        &.clearBtn {
          background: transparent;
          border: 1px solid #7a7c7c;
          color: #424242;
          &:hover {
            background: #1c79be;
            border: 1px solid #1c79be;
            color: #fff;
            .grey_color {
              color: #fff;
            }
          }
        }
      }
      .blue-text {
        font-size: 14px;
        margin-top: 16px;
        width: 100%;
        text-align: center;
        color: #1c79be;
        span {
          width: 100%;
          display: block;
        }
      }
    }
  }
}
.ar .SignalsBox {
  .innerBox {
    .symbol-top-container {
      .instrument {
        padding: 0 16px 0 0;
      }
    }
    .middleDetails {
      .middleDiv {
        ul {
          li {
            .info {
              background-position: 0px 0px;
            }
          }
        }
      }
      > svg {
        transform: rotate(180deg);
        transform-origin: center center;
      }
    }
  }
}

.de .SignalsBox {
  .btnWrap {
    .btn {
      .symbolPrice {
        font-size: 0.875rem;
      }
    }
  }
}

@media only screen and (max-width: 1200px) {
  .SignalsBox .innerBox .middleDetails li > span .tooltip {
    width: 150px;
  }
}
@media only screen and (max-width: 768px) {
  .SignalsBox {
    &.blur {
      &:nth-last-of-type(1),
      &:nth-last-of-type(2) {
        display: none;
      }
    }
    .innerBox .middleDetails li > span tooltip {
      left: 24px;
    }
  }
}
</style>
